import { Controller } from '@hotwired/stimulus'

// TODO(rebranding): delete controller after rebranding is online as it is not used anymore
export default class ImageViewerController extends Controller {
  static targets = ['image', 'mainImage', 'imgContainer', 'zoomContainer']

  connect() {
    this.selectedImage = this.imageTargets[0];
    this.selectedImage.classList.add('selected');
  }

  selectImage(event) {
    this.selectedImage.classList.remove('selected');
    this.selectedImage.classList.add('cursor-pointer');
    this.selectedImage = event.currentTarget;
    this.selectedImage.classList.add('selected');
    this.selectedImage.classList.remove('cursor-pointer');
    this.mainImageTarget.src = this.selectedImage.src;
    this.zoomContainerTarget.querySelector('img').src = this.selectedImage.src;
  }

  filterImages(event) {
    const category = event.currentTarget.dataset.category;

    this.imageTargets.forEach(image => {
      if (!category || image.dataset.category === category) {
        image.closest('[data-image-viewer-target=imgContainer]').classList.remove('d-none');
      } else {
        image.closest('[data-image-viewer-target=imgContainer]').classList.add('d-none');
      }
    });
  }

  toggleZoom() {
    this.zoomContainerTarget.classList.toggle('d-none');
    if (!this.zoomContainerTarget.classList.contains('d-none')) {
      this.zoomContainerTarget.closest('.modal').scrollTo({
        top: 0,
      });
    }
    this.zoomContainerTarget.closest('.modal').classList.toggle('overflow-hidden');
  }
}
